<template>
	<v-container fluid>
		<v-layout row>
			<Header title="Projekt EU" subtitle="www.duris.info" />
		</v-layout>
		<v-layout row wrap align-center justify-center fill-height class="pt-5">
			<v-flex xs12 sm6 md6 lg6>
				<p>
					<strong>Dátum zverejnenia: 28. 1. 2021</strong>
				</p>
				<p>
					<strong>Priložené dokumenty:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/publicita.docx" target="_blank">Publicita.docx</a></li>
					<li><a href="/docs/plagat.pdf" target="_blank">Plagát.pdf</a></li>
				</ul>
				</p>
				<p>
					<strong>Dátum zverejnenia: 19. 02. 2021</strong>
				</p>
				<p>
					<strong>Priložené dokumenty:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/01_Vyzva_SP.pdf" target="_blank">01_Vyzva_SP.pdf</a></li>
					<li><a href="/docs/Pr_c1_VV_stavba.xlsx" target="_blank">Pr_c1_VV_stavba.xlsx</a></li>
					<li><a href="/docs/Pr_c2_ZoD.docx" target="_blank">Pr_c2_ZoD.docx</a></li>
					<li><a href="/docs/Pr_c3_Platobne milniky.xlsx" target="_blank">Pr_c3_Platobne milniky.xlsx</a></li>
				</ul>
				</p>
				<p>
					<strong>Architektúra:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/architektura/Sprievodná správa.pdf" target="_blank">Sprievodná správa.pdf</a></li>
					<li><a href="/docs/architektura/Súhrnná technická správa.pdf" target="_blank">Súhrnná technická
							správa.pdf</a></li>
					<li><a href="/docs/architektura/Technická správa.pdf" target="_blank">Technická správa.pdf</a></li>

					<ul>
						<li><a href="/docs/architektura/vykresova_cast/A01.pdf" target="_blank">A01.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A02.pdf" target="_blank">A02.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A03.pdf" target="_blank">A03.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A04.pdf" target="_blank">A04.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A05.pdf" target="_blank">A05.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A06.pdf" target="_blank">A06.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A07.pdf" target="_blank">A07.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A08.pdf" target="_blank">A08.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A09.pdf" target="_blank">A09.pdf</a></li>
						<li><a href="/docs/architektura/vykresova_cast/A10.pdf" target="_blank">A10.pdf</a></li>
					</ul>
				</ul>
				</p>
				<p>
					<strong>PD Elektro:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/pd_elektro/DT_V2_1154.TBK_SO1.pdf" target="_blank">DT_V2_1154.TBK_SO1.pdf</a></li>
					<li><a href="/docs/pd_elektro/DT_V2_1154.TBK_SO2.pdf" target="_blank">DT_V2_1154.TBK_SO2.pdf</a></li>
					<li><a href="/docs/pd_elektro/LPS_Kľačany - ele_výkr_SO1.pdf" target="_blank">LPS_Kľačany -
							ele_výkr_SO1.pdf</a></li>
					<li><a href="/docs/pd_elektro/LPS_Kľačany - ele_výkr_SO2.pdf" target="_blank">LPS_Kľačany -
							ele_výkr_SO2.pdf</a></li>
					<li><a href="/docs/pd_elektro/LPS_Kľačany - TS.pdf" target="_blank">LPS_Kľačany - TS.pdf</a></li>
				</ul>
				</p>
				<p>
					<strong>Požiar:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/poziar/2019_05_03_PBS_OBNOVA_Haly_a_Priemys_budova_KLACANY_Statikstav_r2_opeciatkovane.pdf"
							target="_blank">2019_05_03_PBS_OBNOVA_Haly_a_Priemys_budova_KLACANY_Statikstav_r2_opeciatkovane.pdf</a>
					</li>
				</ul>
				</p>
				<p>
					<strong>Statika:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/statika/Statické posúdenie stavby.pdf" target="_blank">Statické posúdenie
							stavby.pdf</a></li>
				</ul>
				</p>
				<p>
					<strong>Teplotech posudenie:</strong>
				</p>
				<p>
				<ul>
					<li><a href="/docs/teplotech_posudenie/teplotech  hodnotenie Klacany fin.pdf" target="_blank">teplotech
							hodnotenie Klacany fin.pdf</a></li>
				</ul>
				</p>

			</v-flex>
		</v-layout>
	</v-container>
</template>

<script>
import Header from "@/components/widgets/Header";
export default {
	name: "Cookies",
	components: {
		Header,
	},
	data() {
		return {
			images: [],
		};
	},
};
</script>

<style></style>
